import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column",
  style: {"gap":"0.25rem 0"}
}
const _hoisted_2 = { style: {"margin-left":"0.25rem"} }
const _hoisted_3 = {
  key: 0,
  class: "ms-1 spinner-border spinner-border-sm"
}

import { type Component } from "vue";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";

import { Button, Dots } from "@/components/global";
import { type ButtonVariant } from "@/components/global/Button.vue";

export interface TableActionButton {
  id: string;
  label: string;
  icon: Component | string; 
  action: () => void;
  view?: boolean;
  variant?: ButtonVariant;
  disabled?: boolean;
  loading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TableActionMenu',
  props: {
    menu: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popover), { class: "position-relative" }, {
    default: _withCtx(() => [
      _createVNode(_unref(PopoverButton), { as: "div" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Dots))
        ]),
        _: 1
      }),
      _createVNode(_unref(PopoverPanel), {
        class: "popover-panel panel-left",
        style: {"padding":"0.5rem 0.625rem","width":"max-content","max-width":"13rem","border-radius":"5px"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menu, (button) => {
              return (_openBlock(), _createBlock(_unref(Button), {
                key: button.id,
                onClick: _withModifiers(button.action, ["stop"]),
                "test-id": `${button.id}-action-btn`,
                variant: button?.variant,
                disabled: button?.disabled,
                size: "sm",
                class: "justify-content-start",
                style: {"padding":"0.625rem 0.75rem"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(button.icon), { style: {"width":"1rem","height":"1rem"} })),
                  _createElementVNode("span", _hoisted_2, _toDisplayString(button.label), 1),
                  (button?.loading)
                    ? (_openBlock(), _createElementBlock("output", _hoisted_3))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["onClick", "test-id", "variant", "disabled"]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})